(function () {
  var STORAGE_KEY = 'lamp-lighting-toggle:on';
  var READY_CLASS = 'lighting-toggle--alt-ready';
  var root = document.documentElement;

  // ------------------------------------------------------------------
  // DEBUG-VISNING: åbn siden som .../collections/dit-kategori-handle
  // ?lt_debug=1 på telefonen, så vises en grøn tekstboks nederst på
  // skærmen med log over hvad der sker, når man trykker på kontakten.
  // Helt usynlig uden ?lt_debug=1 i linket.
  // ------------------------------------------------------------------
  var DEBUG = /[?&]lt_debug=1\b/.test(window.location.search);
  var debugEl = null;
  function debugLog(msg) {
    if (!DEBUG) return;
    if (!debugEl) {
      debugEl = document.createElement('div');
      debugEl.style.cssText =
        'position:fixed;bottom:0;left:0;right:0;max-height:45vh;overflow:auto;' +
        'background:rgba(0,0,0,0.92);color:#7CFC7C;font:11px/1.4 monospace;' +
        'padding:8px;z-index:2147483647;white-space:pre-wrap;box-sizing:border-box;';
      (document.body || document.documentElement).appendChild(debugEl);
    }
    var line = document.createElement('div');
    line.textContent = new Date().toISOString().slice(11, 19) + '  ' + msg;
    debugEl.appendChild(line);
    debugEl.scrollTop = debugEl.scrollHeight;
  }

  function getInputs() {
    return document.querySelectorAll('[data-lighting-toggle-input]');
  }

  function markReady(img, via) {
    var wrapper = img.closest('.ProductItem__ImageWrapper');
    if (wrapper) wrapper.classList.add(READY_CLASS);
    debugLog('KLAR (' + via + '): ' + (img.currentSrc || img.src || '(intet src)'));
  }

  function isImgLoaded(img) {
    return img.classList.contains('lazyloaded') || (img.complete && img.naturalWidth > 0);
  }

  // Sikkerhedsnet: sæt billedets rigtige src manuelt ud fra data-src,
  // helt uafhængigt af lazysizes. Bruges kun hvis lazysizes' egen
  // unveil() ikke selv har leveret billedet inden for kort tid.
  function manuallyResolveImage(img) {
    if (isImgLoaded(img)) {
      markReady(img, 'allerede indlæst');
      return;
    }
    var dataSrc = img.getAttribute('data-src');
    debugLog('Manuel fallback. data-src = ' + (dataSrc || '(mangler helt)'));
    if (!dataSrc) return;

    var wrapper = img.closest('.ProductItem__ImageWrapper');
    var widthGuess =
      (wrapper && wrapper.getBoundingClientRect().width) ||
      img.getBoundingClientRect().width ||
      0;
    if (!widthGuess || widthGuess < 100) {
      debugLog('Bredde målt for lille (' + widthGuess + 'px) - bruger 700px i stedet');
      widthGuess = 700;
    }
    var width = Math.min(Math.round(widthGuess * (window.devicePixelRatio || 1)), 1200);

    var resolvedSrc =
      dataSrc.indexOf('{width}') > -1 ? dataSrc.replace('{width}', width) : dataSrc;

    debugLog('Forsøger src = ' + resolvedSrc);

    img.removeAttribute('data-src');
    img.addEventListener(
      'load',
      function () {
        markReady(img, 'manuel src lykkedes');
      },
      { once: true }
    );
    img.addEventListener(
      'error',
      function () {
        debugLog('FEJL ved indlæsning af: ' + resolvedSrc);
      },
      { once: true }
    );
    img.src = resolvedSrc;
  }

  // Tving billede 2 til at blive hentet med det samme (i stedet for at
  // vente på at det ruller ind i viewport, eller bliver hovered) — det
  // er det der mangler på mobil, hvor der hverken er hover, og hvor man
  // ofte rammer kontakten før man har rullet forbi kortet.
  function ensureAlternateImagesLoaded() {
    var altImages = document.querySelectorAll(
      '.ProductItem__ImageWrapper--withAlternateImage .ProductItem__Image--alternate'
    );
    debugLog('Fandt ' + altImages.length + ' alternative billeder på siden');
    altImages.forEach(function (img, i) {
      if (isImgLoaded(img)) {
        markReady(img, 'var allerede indlæst #' + i);
        return;
      }
      var hasLazySizes =
        window.lazySizes &&
        window.lazySizes.loader &&
        typeof window.lazySizes.loader.unveil === 'function';
      debugLog('#' + i + ' ikke indlæst endnu. lazySizes tilgængelig: ' + hasLazySizes);
      if (hasLazySizes) {
        window.lazySizes.loader.unveil(img);
      }
      // Giv lazysizes en kort chance for selv at klare det (den sætter
      // klassen 'lazyloaded' når billedet er hentet), men hvis intet er
      // sket efter 200ms, sætter vi selv billedet.
      window.setTimeout(function () {
        manuallyResolveImage(img);
      }, 200);
    });

    // Ekstra diagnostik (kun med ?lt_debug=1): dump den faktiske
    // beregnede CSS for de første par kort et halvt sekund senere.
    if (DEBUG) {
      window.setTimeout(function () {
        debugLog('--- Status for de 3 første kort ---');
        for (var i = 0; i < Math.min(3, altImages.length); i++) {
          var altImg = altImages[i];
          var wrapper = altImg.closest('.ProductItem__ImageWrapper');
          var mainImg = wrapper
            ? wrapper.querySelector('.ProductItem__Image:not(.ProductItem__Image--alternate)')
            : null;
          var altStyle = getComputedStyle(altImg);
          var mainStyle = mainImg ? getComputedStyle(mainImg) : null;
          debugLog('Kort #' + i + ' wrapper-klasser: ' + (wrapper ? wrapper.className : '(ingen wrapper)'));
          debugLog(
            'Kort #' + i + ' billede2: opacity=' + altStyle.opacity + ' display=' + altStyle.display + ' visibility=' + altStyle.visibility
          );
          debugLog('Kort #' + i + ' billede2 URL: ' + (altImg.currentSrc || altImg.src || '(intet)'));
          if (mainStyle) {
            debugLog(
              'Kort #' + i + ' billede1: opacity=' + mainStyle.opacity + ' display=' + mainStyle.display + ' visibility=' + mainStyle.visibility
            );
            debugLog('Kort #' + i + ' billede1 URL: ' + (mainImg.currentSrc || mainImg.src || '(intet)'));
          }
        }
      }, 600);
    }
  }

  function applyState(isOn) {
    root.classList.toggle('lights-on', isOn);
    getInputs().forEach(function (input) {
      input.checked = isOn;
    });
    debugLog('Kontakt slået ' + (isOn ? 'TIL' : 'FRA'));
    if (isOn) {
      ensureAlternateImagesLoaded();
    }
  }

  function storeState(isOn) {
    try {
      localStorage.setItem(STORAGE_KEY, isOn ? '1' : '0');
    } catch (e) {
      /* privat browsing / blokeret storage - ingen huskefunktion, men kontakten virker stadig */
    }
  }

  function readStoredState() {
    try {
      return localStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function init() {
  // Kør kun lysfunktionen på sider, hvor lyskontakten vises.
  if (!document.querySelector('[data-lighting-toggle-input]')) {
    root.classList.remove('lights-on', 'lighting-is-switching');

    document.querySelectorAll('.lighting-toggle--alt-ready')
      .forEach(function (card) {
        card.classList.remove('lighting-toggle--alt-ready');
      });

    return;
  }

  if (DEBUG) debugLog('Script startet. lt_debug er aktiv.');


    // Så snart lazysizes selv melder et billede indlæst, markerer vi
    // dets kort som "klar" — uanset om det skete via almindelig scroll,
    // hover, eller vores eget forcerede unveil() herover.
    document.addEventListener('lazyloaded', function (event) {
      var img = event.target;
      if (img && img.classList && img.classList.contains('ProductItem__Image--alternate')) {
        markReady(img, 'lazysizes lazyloaded-event');
      }
    });

    applyState(readStoredState());

    document.addEventListener('change', function (event) {
      if (!event.target.matches('[data-lighting-toggle-input]')) return;
      var isOn = event.target.checked;
      applyState(isOn);
      storeState(isOn);
    });

    // Hvis produktgitteret opdateres (filtrering, uendelig scroll/"vis
    // flere"), og lyset allerede er tændt, skal de nye kort også have
    // hentet billede 2.
    var grid = document.querySelector('.CollectionInner');
    if (grid && window.MutationObserver) {
      var observer = new MutationObserver(function () {
        if (root.classList.contains('lights-on')) {
          ensureAlternateImagesLoaded();
        }
      });
      observer.observe(grid, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
(function () {
  var fadeTimer;

  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-lighting-toggle-input]')) return;

    var root = document.documentElement;

    clearTimeout(fadeTimer);
    root.classList.add('lighting-is-switching');

    fadeTimer = setTimeout(function () {
      root.classList.remove('lighting-is-switching');
    }, 550);
  }, true);
})();
